<!-- Template -->

<template>
    <div></div>
</template>

<!-- Script -->

<script>
    export default {
        name: "ResetPasswordToken",

        beforeCreate() {
            var token = window.location.href.split("/reset-password/")[1];
            localStorage.setItem("resetToken", token);
            window.location.href = "/reset-password";
        }
    };
</script>

<!-- Style -->

<style scoped lang="scss" src="@/styles/pages/_login.scss" />